import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ProcedureMoveAppBar from "../../../common/ProcedureMoveAppBar.js";
import Snackbar from "../../../common/Snackbar.js";
import { moveSection, copyElement } from "../../../redux/sectionSlice.js";
import { generateSHA256 } from "../../../util/generateSHA256.js";
import RenderHtml from "../../../common/AppSpecificConpnents/PartsTable/RenderHtml.js";
import {
  HeadingWithTreePath,
  generateCompleteTreePath,
} from "../../SubassemblyDetails/utils/treePathUtils.js";
import { getPages, renderPreview, renderVideo } from "../plugins/utils.js";
import {
  applyTransparency,
  calculateGroupHeight,
  calculateTextBlockWidth,
  estimateKonvaTextHeight,
  formatListContent,
  getTextStyle,
  hasNoteContent,
  hasTaskContent,
  hasUserContent,
  measureHtmlHeight,
  stripHtmlPreserveFormatting,
} from "../plugins/utils.js";
import RectangleElement from "../../Canvas/components/rectangle/RectangleElement.jsx";
import ArrowElement from "../../Canvas/components/arrow/ArrowElement.jsx";
import CircleElement from "../../Canvas/components/circle/CircleElement.jsx";
import LineElement from "../../Canvas/components/line/LineElement.jsx";
import CanvasImage from "../../Canvas/components/canvas-core/CanvasImage.jsx";
import TextElement from "../../Canvas/components/text/TextElement.jsx";
import DoubleSidedArrowElement from "../../Canvas/components/arrow/DoubleSidedArrowElement.jsx";
import CanvasDisplay from "../../Canvas/components/canvas-core/CanvasDisplay.jsx";
import {
  extractVersionStructure,
  getAuditTrailData,
} from "../../../util/getAuditTrailData.js";
import { getRevAllNodes } from "../../../redux/procedureRevisionSlice.js";
const ProcedureSectionMovePreview = () => {
  const { sections } = useSelector((state) => state.section);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let richTextCounter = 1;
  let canvasCounter = 1;
  let videoCounter = 1;
  let formCounter = 1;
  let substepCounter = 1;
  const [isLoading, setIsLoading] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const [auditData, setAuditData] = useState({
    user_ref: localStorage.getItem("user_id") || "",
    ip_address: "",
    device_info: navigator.userAgent,
    hash: generateSHA256(Math.random().toString()),
    signature: "",
  }); // Fetch IP address and generate hash
  let richTextsCounter = {};
  let attachmentCounter = 1;
  const [isModalOpen, setModalOpen] = useState(false);
  const [comment, setComment] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    type: "",
  });
  const {
    stepsBySection,
    substepsByStep,
    richTexts,
    attachments,
    forms,
    canvases,
    videos,
  } = useSelector((state) => state.step);

  const { allRevisionNodes } = useSelector((state) => state.procedureRevision);

  const [selectedView, setSelectedView] = useState("new");

  const {
    moveType,
    sourceSectionIndex,
    targetSectionIndex,
    revision,
    partNumber,
    type,
    partId,
    revisionId,
    fromTreeId,
    fromSectionId,
    targetSectionData,
    fromSiblingOrder,
    procedureName,
    status,
    createCopy,
  } = location.state;

  // Show appropriate snackbar message based on operation type
  useEffect(() => {
    if (sourceSectionIndex >= 0 && sourceSectionIndex < sections.length) {
      if (moveType === "into") {
        showSnackbar(
          `Section ${sourceSectionIndex + 1} will be ${
            createCopy ? "copied into" : "moved into"
          } ${type} ${partNumber}`,
          "info"
        );
      } else {
        showSnackbar(
          `Section ${sourceSectionIndex + 1} will be ${
            createCopy ? "copied" : "moved"
          } ${moveType === "up" ? "above" : "below"} Section ${
            targetSectionIndex + 1
          }`,
          "info"
        );
      }
    }
  }, [
    sourceSectionIndex,
    targetSectionIndex,
    moveType,
    sections,
    type,
    partNumber,
    createCopy,
  ]);

  useEffect(() => {
    if (fromSectionId) {
      dispatch(
        getRevAllNodes({
          partId: partId,
          revisionId: revisionId,
        })
      );
    }
  }, [dispatch, partId, revisionId, fromSectionId]);

  const showSnackbar = (message, type) => {
    setSnackbar({ open: true, message, type });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleConfirm = () => {
    setModalOpen(true);
  };

  const compareSiblingOrders = (a, b) => {
    const intA = parseInt(a, 10);
    const intB = parseInt(b, 10);
    return intA - intB;
  };
  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) =>
        setAuditData((prev) => ({ ...prev, ip_address: data.ip }))
      )
      .catch((err) => console.error("Failed to fetch IP:", err));
  }, []);

  const handleConfirmSave = async () => {
    if (!comment.trim()) {
      showSnackbar("Please enter a comment before confirming.", "error");
      return;
    }

    setIsModalLoading(true);
    try {
      if (createCopy) {
        // Use copyElement API for copy operations
        const hash = await generateSHA256(Math.random().toString());

        const copyPayload = {
          from_procedure_tree_node_ref: fromTreeId,
          from_order: parseInt(fromSiblingOrder),
          from_type: "section",
          from_part_id_ref: partId,
          from_procedure_rev_ref: revisionId,
          from_section_id_ref: fromSectionId,
          from_step_id_ref: "",
          from_substep_id_ref: "",
          to_procedure_tree_node_ref:
            targetSectionData?.sectionTreeId || revisionId,
          to_order: (() => {
            if (moveType === "into") {
              // For copy into procedure, get the highest sibling order and add 1
              const highestSiblingOrder = sections.reduce((max, section) => {
                const order = parseInt(section.sibling_order || 0);
                return order > max ? order : max;
              }, -Infinity);
              return highestSiblingOrder + 1;
            } else if (moveType === "up") {
              return parseInt(targetSectionData?.siblingOrder);
            } else {
              return parseInt(targetSectionData?.siblingOrder) + 1;
            }
          })(),
          to_type: "section",
          to_part_id_ref: partId,
          to_procedure_rev_ref: revisionId,
          to_section_id_ref:
            moveType === "into" ? null : targetSectionData?.sectionId,
          to_step_id_ref: "",
          to_substep_id_ref: "",
          direction:
            moveType === "up"
              ? "paste_up"
              : moveType === "below"
              ? "paste_down"
              : "paste_down",
          audit_trail_data: {
            ...auditData,
            hash,
            action:
              moveType === "up"
                ? "paste_up"
                : moveType === "below"
                ? "paste_down"
                : "paste_down",
            comment: `Copied Section ${sourceSectionIndex + 1} ${
              moveType === "up"
                ? "above"
                : moveType === "below"
                ? "below"
                : "into"
            } ${
              moveType === "into"
                ? `${type} ${partNumber}`
                : `Section ${targetSectionIndex + 1}`
            } in ${partNumber}, Rev ${revision}`,
            date: new Date().toISOString(),
            parent_version: null,
            version_content: {
              rule_name: "Field Changes Tracking",
              modified_fields: {},
            },
          },
        };

        // Log detailed info about the copy operation
        await dispatch(copyElement(copyPayload)).unwrap();
        showSnackbar("Section copied successfully!", "success");
        navigate(-3); // Navigate back to the previous page
      } else {
        // Use moveSection API for move operations
        const parent_version =
          sections?.find((s) => s.section_tree_node_id === fromSectionId)
            ?.version_id_ref ?? null;

        let newContent = structuredClone(allRevisionNodes);
        const cursection = allRevisionNodes.find(
          (s) => s.section_id_ref === fromSectionId
        );

        // For move operations, remove from original position and place at target
        if (moveType === "into") {
          newContent = newContent.filter(
            (nc) => nc.section_id_ref !== fromSectionId
          );
          newContent = [...newContent, cursection];
        } else if (moveType === "up" || moveType === "below") {
          newContent = newContent.filter(
            (nc) => nc.section_id_ref !== fromSectionId
          );
          const index = newContent.findIndex(
            (s) => s.section_id_ref === targetSectionData.sectionId
          );
          if (index !== -1) {
            if (moveType === "up" && index === 0) {
              newContent.unshift(cursection);
            } else {
              newContent.splice(
                moveType === "up" ? index : index + 1,
                0,
                cursection
              );
            }
          }
        }

        const audit_trail_data = await getAuditTrailData(
          {
            action: "SECTION_MOVED",
            comment: comment,
            parent_version: parent_version,
            version_content: {
              action_to_show: `Moved Section ${sourceSectionIndex + 1} ${
                moveType === "up"
                  ? "above"
                  : moveType === "below"
                  ? "below"
                  : "into"
              } ${
                moveType === "into"
                  ? `${type} ${partNumber}`
                  : `Section ${targetSectionIndex + 1}`
              } in ${partNumber}, Rev ${revision}`,
              originingalContent: extractVersionStructure(allRevisionNodes),
              newContent: extractVersionStructure(newContent),
              moveType,
              rev: revision,
              status,
              type,
              item_code_type: type,
              partNumber,
              move_copy_action: `Section ${
                targetSectionIndex + 1
              } in ${partNumber}, Rev ${revision}`,
            },
          },
          false
        );
        const payload = {
          from_procedure_tree_node_ref: fromTreeId,
          from_order: parseInt(fromSiblingOrder),
          from_type: "section",
          from_part_id_ref: partId,
          from_procedure_rev_ref: revisionId,
          from_section_id_ref: fromSectionId,
          from_step_id_ref: null,
          from_substep_id_ref: null,
          to_procedure_tree_node_ref: revisionId,
          to_order: (() => {
            const targetOrder = parseInt(targetSectionData?.siblingOrder || 0);
            if (moveType === "below") {
              // If moving from a later position to an earlier position
              if (parseInt(fromSiblingOrder) > targetOrder) {
                return targetOrder + 1;
              }
              // If moving from an earlier position to a later position
              return targetOrder;
            }
            return targetOrder;
          })(),
          to_type: "section",
          to_part_id_ref: partId,
          to_procedure_rev_ref: revisionId,
          to_section_id_ref:
            moveType === "into" ? null : targetSectionData?.sectionId,
          to_step_id_ref: null,
          to_substep_id_ref: null,
          direction_move_into: moveType === "into" ? true : false,
          direction:
            moveType === "up"
              ? "move_up"
              : moveType === "below"
              ? "move_down"
              : "move_down",
          create_copy: createCopy,
          audit_trail_data,
        };

        // Ensure numeric values for API call
        payload.from_order = Number(payload.from_order);
        payload.to_order = Number(payload.to_order);

        // Ensure we have valid values for required fields
        if (!payload.from_procedure_tree_node_ref) {
          payload.from_procedure_tree_node_ref = revisionId;
        }

        if (!payload.to_procedure_tree_node_ref) {
          payload.to_procedure_tree_node_ref = revisionId;
        }

        // For move_into, the target is the procedure revision itself
        if (moveType === "into") {
          payload.to_procedure_tree_node_ref = revisionId;
          payload.to_section_id_ref = null;
        }

        // Log detailed info about the move operation
        await dispatch(moveSection(payload)).unwrap();
        showSnackbar("Section moved successfully!", "success");
        navigate(-3); // Navigate back to the previous page
      }
    } catch (error) {
      console.error("Error during operation:", error);
      showSnackbar(
        `Error ${createCopy ? "copying" : "moving"} section: ` + error?.message,
        "error"
      );
    } finally {
      setIsModalLoading(false);
    }
  };

  const getSortedSections = () => {
    // Create a deep copy of the sections array to avoid mutating Redux state
    const sectionsCopy = sections.map((section) => ({ ...section }));

    return sectionsCopy.sort((a, b) => {
      const orderA = a.sibling_order || a.procedure_tree?.sibling_order;
      const orderB = b.sibling_order || b.procedure_tree?.sibling_order;

      const orderCompare = compareSiblingOrders(orderA, orderB);
      if (orderCompare !== 0) return orderCompare;

      // Fallback: compare created_at
      const dateA = new Date(a.created_at);
      const dateB = new Date(b.created_at);
      return dateB - dateA; // latest comes first
    });
  };

  const getReorderedSections = (
    sections,
    sourceIndex,
    targetIndex,
    moveType,
    viewType,
    createCopy = false
  ) => {
    if (viewType === "original") return sections;

    const updated = [...sections];

    // Only proceed if we have valid indices
    if (sourceIndex < 0 || sourceIndex >= updated.length) {
      return updated;
    }

    const sourceSection = updated[sourceIndex];
    // If createCopy is true, we don't remove the source section
    // We just add a copy at the target position
    if (createCopy) {
      // Determine insertion index for the copy
      let insertAt;

      if (moveType === "into") {
        insertAt = updated.length; // insert at end
      } else {
        insertAt = targetIndex;

        // For "below", we want to insert after the target
        if (moveType === "below") {
          insertAt += 1;
        }

        // When copying, we don't need to adjust for removing from above
        // since we're not removing the source section
      }

      // Clamp the value
      insertAt = Math.max(0, Math.min(insertAt, updated.length));


      // Create a copy of the source section and insert it
      const sectionCopy = { ...sourceSection };
      updated.splice(insertAt, 0, sectionCopy);

  

      return updated;
    } else {
      // Original logic for moving (not copying)
      // Remove the source section
      const [movedSection] = updated.splice(sourceIndex, 1);

      // Determine insertion index
      let insertAt;

      if (moveType === "into") {
        insertAt = updated.length; // insert at end
      } else {
        insertAt = targetIndex;

        // For "below", we want to insert after the target
        if (moveType === "below") {
          insertAt += 1;
        }

        // Adjust if removing from above
        if (sourceIndex < targetIndex) {
          insertAt = Math.max(0, insertAt - 1);
        }

        // Clamp the value
        insertAt = Math.max(0, Math.min(insertAt, updated.length));
      }

      // Re-insert at the calculated position
      updated.splice(insertAt, 0, movedSection);

      return updated;
    }
  };

  const getPreviewData = (viewType) => {
    return getReorderedSections(
      getSortedSections(),
      sourceSectionIndex,
      targetSectionIndex,
      moveType,
      viewType,
      createCopy
    );
  };
  const reorderedPreviewSections = getPreviewData(selectedView);

  return (
    <div style={{ position: "relative" }}>
      {/* Main Page Loader */}
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            }}
          >
            <div
              style={{
                border: "4px solid #f3f3f3",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                animation: "spin 1s linear infinite",
                marginBottom: "10px",
              }}
            ></div>
            <div style={{ fontSize: "16px", color: "#333" }}>
              {createCopy ? "Copying" : "Moving"} section...
            </div>
          </div>
        </div>
      )}

      <ProcedureMoveAppBar
        selectedView={selectedView}
        showBackButton={false}
        setSelectedView={setSelectedView}
        title="Please Confirm the Changes"
        buttons={[{ label: "Confirm", onClick: handleConfirm }]}
      />

      {/* Procedure Header Information */}
      <div style={{ padding: "15px 20px" }}>
        <table style={{ width: "100%" }}>
          <tr>
            <td style={{ width: "66%", fontSize: "20px" }}>
              <strong>
                {type} {partNumber}
              </strong>
            </td>
            <td style={{ width: "17%" }}>
              <strong>Status:</strong>{" "}
              <span style={{ color: "orange" }}>{location.state.status}</span>
            </td>
            <td style={{ width: "17%", textAlign: "right" }}>
              <strong>Revision:</strong> {revision}
            </td>
          </tr>
        </table>
      </div>

      <div
        className="header-spacing"
        style={{ padding: "20px", marginTop: "-10px" }}
      >
        <div style={{ marginTop: "20px" }}>
          {reorderedPreviewSections.map((section, index) => {
            return (
              <div
                key={section.section_tree_node_id}
                style={{
                  margin: "20px 0",
                  clear: "both",
                }}
              >
                {/* Simple heading for sections without tree path */}
                <h2
                  style={{
                    fontSize: "20px",
                    margin: 0,
                    clear: "both",
                    color: "#000",
                  }}
                >
                  Section {index + 1}
                </h2>
                <hr />
                <hr />
                <div>{section.section_name}</div>
                <div>{section.short_description}</div>

                {/* Steps for this section */}
                {(stepsBySection[section.section_tree_node_id] || []).map(
                  (step, stepIndex) => {
                    const stepId = step.step_tree_node_id;
                    const sectionId = section.section_tree_node_id;
                    const stepsBeforeThisSection = reorderedPreviewSections
                      .slice(0, index)
                      .reduce(
                        (acc, s) =>
                          acc +
                          (stepsBySection[s.section_tree_node_id]?.length || 0),
                        0
                      );
                    const globalStepNumber =
                      stepsBeforeThisSection + stepIndex + 1;

                    // Store the section index to use in the inner loops
                    const currentSectionIndex = index;

                    const substeps = substepsByStep[stepId] || [];

                    const substepLetter = String.fromCharCode(
                      65 + substeps.length
                    ); // A, B, C...

                    // Calculate media counters before navigation
                    const currentAttachmentCounter = attachmentCounter;
                    const currentVideoCounter = videoCounter;
                    const currentFormCounter = formCounter;
                    const currentCanvasCounter = canvasCounter;
                    const currentRichTextCounter = richTextCounter;

                    // Update counters for next step
                    //attachmentCounter += myAttachments.length;
                    // videoCounter += myVideos.length;
                    // formCounter += myForms.length;
                    // canvasCounter += myCanvases.length;
                    // richTextCounter += myRichTexts.length; // If you're adding one richText per step

                    richTextsCounter[stepId] = currentRichTextCounter;

                    const combinedItems = [
                      ...(richTexts[stepId] || []).map((item) => ({
                        ...item,
                        type: "richText",
                      })),
                      ...(forms[stepId] || []).map((item) => ({
                        ...item,
                        type: "form",
                      })),
                      ...(attachments[stepId] || []).map((item) => ({
                        ...item,
                        type: "attachment",
                      })),
                      ...(canvases[stepId] || []).map((item) => ({
                        ...item,
                        type: "canvas",
                      })),
                      ...(videos[stepId] || []).map((item) => ({
                        ...item,
                        type: "video",
                      })),
                    ]; // Filter out substeps or unwanted items (same as your current filter)
                    const filteredItems = combinedItems.filter(
                      (item) =>
                        !item.substep_id_ref && !item.sub_step_tree_node_id
                    );

                    filteredItems.sort((a, b) => {
                      const orderA =
                        a.sibling_order || a.procedure_tree?.sibling_order;
                      const orderB =
                        b.sibling_order || b.procedure_tree?.sibling_order;

                      const orderCompare = compareSiblingOrders(orderA, orderB);
                      if (orderCompare !== 0) return orderCompare;

                      // Fallback: compare created_at
                      const dateA = new Date(a.created_at);
                      const dateB = new Date(b.created_at);
                      return dateB - dateA; // latest comes first
                    });
                    const allChildrenUnderStep = [
                      ...(richTexts[stepId] || []),
                      ...(forms[stepId] || []),
                      ...(attachments[stepId] || []),
                      ...(canvases[stepId] || []),
                      ...(videos[stepId] || []),
                      // Also optionally substeps, if they have sibling_order
                    ];

                    return (
                      <div
                        key={stepId}
                        style={{ marginTop: "20px", clear: "both" }}
                      >
                        <HeadingWithTreePath
                          title={`Step ${globalStepNumber}`}
                          treePathParams={{
                            sectionIndex: index,
                            stepIndex: globalStepNumber - 1,
                            substepIndex: undefined,
                            nodeType: undefined,
                            nodeIndex: undefined,
                          }}
                        />
                        <hr />
                        <p style={{ whiteSpace: 'pre-wrap' }}>{step.short_description || ""}</p>
                        <p>
                          <p>
                            {structuredClone(step.step_details)
                              .sort(
                                (a, b) =>
                                  new Date(a.created_at) -
                                  new Date(b.created_at)
                              )
                              .map((myStep) => {
                                const partNumber =
                                  myStep.part_info?.part_number || "";
                                const description =
                                  myStep.part_info?.description || "";
                                const qtyText =
                                  myStep.qty && myStep.qty != 0
                                    ? `Qty ${myStep.qty}`
                                    : "";

                                const partText = partNumber
                                  ? ` (${partNumber})`
                                  : "";

                                return (
                                  <>
                                    {myStep.action}
                                    {partText}{" "}
                                    <RenderHtml content={description} />{" "}
                                    {qtyText}&nbsp;
                                  </>
                                );
                              })}
                          </p>
                        </p>

                        <h4>
                          {step.bom_table_title_info?.category_name || ""}
                        </h4>

                        <table className="table">
                          <thead>
                            <tr>
                              <th>Type</th>
                              <th>
                                {
                                  step.part_number_column_title_ref_info
                                    ?.category_name
                                }{" "}
                              </th>
                              <th>Description</th>
                              <th>Qty Per</th>
                              <th>Unit</th>
                            </tr>
                          </thead>

                          <tbody>
                            {step.parts_required.map((row) => (
                              <tr>
                                <td>{row.part_info.type_info.name}</td>
                                <td>{row.part_info.part_number}</td>
                                <td>
                                  <RenderHtml
                                    content={row.part_info.description}
                                  />{" "}
                                </td>
                                <td>{row.qty === 0 ? "" : row.qty}</td>
                                <td>{row.part_info?.unit_info?.unit_name}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        {/* Step Content */}

                        {filteredItems.map((item, itemIndex) => {
                          if (item.substep_id_ref || item.sub_step_tree_node_id)
                            return null;
                          switch (item.type) {
                            case "richText": {
                              const globalRichTextNumber = richTextCounter++; // ✅ use then increment
                              // render richText block here
                              const label = (
                                <h2
                                  style={{
                                    fontSize: "20px",
                                    margin: 0,
                                    color: "#000",
                                  }}
                                >
                                  Rich Text {globalRichTextNumber}
                                </h2>
                              );

                              return (
                                <div
                                  key={item.rich_text_tree_node_id}
                                  style={{ marginTop: "20px" }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      clear: "both",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        cursor: "pointer",
                                        clear: "both",
                                      }}
                                    >
                                      {label}
                                    </label>

                                    <div
                                      style={{
                                        color: "#888",
                                        fontSize: "14px",
                                        fontWeight: "normal",
                                        clear: "both",
                                      }}
                                    >
                                      Section {index + 1} &gt; Step{" "}
                                      {globalStepNumber}
                                    </div>
                                  </div>

                                  <div
                                    style={{
                                      marginLeft: "5px",
                                      marginTop: "-10px",
                                      clear: "both",
                                    }}
                                  >
                                    {item.short_description}
                                  </div>
                                  <div
                                    style={{
                                      marginLeft: "4px",
                                      marginTop: "10px",
                                      clear: "both",
                                    }}
                                  >
                                    {item.category_data?.category_name}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "20px",
                                      marginLeft: "4px",
                                      marginTop: "5px",
                                      clear: "both",
                                    }}
                                  >
                                    <div
                                      style={{
                                        marginTop: "-6px",
                                        clear: "both",
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: item.rich_text_content,
                                      }}
                                    />
                                  </div>
                                </div>
                              );
                            }
                            case "video": {
                              const globalVideoNumber = videoCounter++; // ✅ use then increment
                              const label = (
                                <h2
                                  style={{
                                    fontSize: "20px",
                                    margin: 0,
                                    color: "#000",
                                  }}
                                >
                                  Video {globalVideoNumber}
                                </h2>
                              );

                              return (
                                <div
                                  key={label}
                                  style={{ marginTop: "20px", clear: "both" }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      clear: "both",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        cursor: "pointer",
                                        clear: "both",
                                      }}
                                    >
                                      {label}
                                    </label>

                                    <div
                                      style={{
                                        color: "#888",
                                        fontSize: "14px",
                                        fontWeight: "normal",
                                        clear: "both",
                                      }}
                                    >
                                      Section {index + 1} &gt; Step{" "}
                                      {globalStepNumber}
                                    </div>
                                  </div>

                                  {renderVideo(item)}

                                  <div>{item.video_url}</div>

                                  <div>{item.short_description}</div>
                                </div>
                              );
                            }

                            case "form": {
                              const globalFormNumber = formCounter++; // ✅ use then increment
                              const label = (
                                <h2
                                  style={{
                                    fontSize: "20px",
                                    margin: 0,
                                    color: "#000",
                                  }}
                                >
                                  Form {globalFormNumber}
                                </h2>
                              );
                              // render form block here
                              return (
                                <div
                                  key={label}
                                  style={{ marginTop: "20px", clear: "both" }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      marginTop: "20px",
                                      clear: "both",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        cursor: "pointer",
                                        clear: "both",
                                      }}
                                    >
                                      {label}
                                    </label>

                                    <div
                                      style={{
                                        color: "#888",
                                        fontSize: "14px",
                                        fontWeight: "normal",
                                        clear: "both",
                                      }}
                                    >
                                      Section {index + 1} &gt; Step{" "}
                                      {globalStepNumber}
                                    </div>
                                  </div>
                                  <div>{item.short_description}</div>
                                </div>
                              );
                            }
                            case "canvas": {
                              const pages = getPages(item);

                              const globalCanvasNumber = canvasCounter++; // ✅ use then increment
                              const label = (
                                <h2
                                  style={{
                                    fontSize: "20px",
                                    margin: 0,
                                    color: "#000",
                                  }}
                                >
                                  Canvas {globalCanvasNumber}
                                </h2>
                              );
                              const shapes = item.shapes || [];

                              return (
                                <div
                                  key={label}
                                  style={{ marginTop: "40px", clear: "both" }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      clear: "both",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        cursor: "pointer",
                                        clear: "both",
                                      }}
                                    >
                                      <h2>{label}</h2>
                                    </label>

                                    <div
                                      style={{
                                        color: "#888",
                                        fontSize: "14px",
                                        fontWeight: "normal",
                                        clear: "both",
                                      }}
                                    >
                                      Section {index + 1} &gt; Step{" "}
                                      {globalStepNumber}
                                    </div>
                                  </div>

                                  <div>{item.short_description}</div>

                                  {/* Display all pages vertically */}
                                  <CanvasDisplay pages={pages} />
                                </div>
                              );
                            }
                            case "attachment": {
                              const attachmentList = item.attachments || [];
                              if (attachmentList.length === 0) return null;

                              //  const globalAttachmentNumber =
                              //           attachmentCounter++; // ✅ use then increment
                              const globalAttachmentNumber =
                                attachmentCounter++; // ✅ Increment here per attachment
                              const label = (
                                <h2
                                  style={{
                                    fontSize: "20px",
                                    margin: 0,
                                    color: "#000",
                                  }}
                                >
                                  Attachment {globalAttachmentNumber}
                                </h2>
                              );

                              return (
                                <div
                                  key={item}
                                  style={{ marginTop: "20px", clear: "both" }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                      marginTop: "20px",
                                      clear: "both",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        cursor: "pointer",
                                        clear: "both",
                                      }}
                                    >
                                      {label}
                                    </label>

                                    <div
                                      style={{
                                        color: "#888",
                                        fontSize: "14px",
                                        fontWeight: "normal",
                                        clear: "both",
                                      }}
                                    >
                                      Section {index + 1} &gt; Step{" "}
                                      {globalStepNumber}
                                    </div>
                                  </div>
                                  <div>{item.short_description}</div>
                                  {attachmentList.map((attachment, i) => (
                                    <div
                                      key={i}
                                      style={{
                                        marginLeft: "20px",
                                        clear: "both",
                                      }}
                                    >
                                      {renderPreview(attachment)}
                                    </div>
                                  ))}
                                </div>
                              );
                            }
                            default:
                              return null;
                          }
                        })}

                        {/* Substeps */}
                        {(substepsByStep[stepId] || []).map(
                          (substep, substepIndex) => {
                            const substepId = substep.sub_step_tree_node_id;
                            const combinedItems = [
                              ...(richTexts[substepId] || []).map((item) => ({
                                ...item,
                                type: "richText",
                              })),
                              ...(forms[substepId] || []).map((item) => ({
                                ...item,
                                type: "form",
                              })),
                              ...(attachments[substepId] || []).map((item) => ({
                                ...item,
                                type: "attachment",
                              })),
                              ...(canvases[substepId] || []).map((item) => ({
                                ...item,
                                type: "canvas",
                              })),
                              ...(videos[substepId] || []).map((item) => ({
                                ...item,
                                type: "video",
                              })),
                            ]; // Filter out substeps or unwanted items (same as your current filter)
                            const filteredItems = combinedItems;

                            filteredItems.sort((a, b) => {
                              const orderA =
                                a.sibling_order ||
                                a.procedure_tree?.sibling_order;
                              const orderB =
                                b.sibling_order ||
                                b.procedure_tree?.sibling_order;

                              const orderCompare = compareSiblingOrders(
                                orderA,
                                orderB
                              );
                              if (orderCompare !== 0) return orderCompare;

                              // Fallback: compare created_at
                              const dateA = new Date(a.created_at);
                              const dateB = new Date(b.created_at);
                              return dateB - dateA; // latest comes first
                            });

                            // Use the parent step's number as the base for substep
                            // We're already in the step scope, so we can use the existing globalStepNumber variable

                            // Final substep label like Substep 5A
                            const substepLetter = String.fromCharCode(
                              65 + substepIndex
                            ); // A, B, C, ...
                            const newSubstepLetter = String.fromCharCode(
                              65 + substepIndex + 1
                            );
                            const allChildrenUnderSubstep = [
                              ...(richTexts[substepId] || []),
                              ...(forms[substepId] || []),
                              ...(attachments[substepId] || []),
                              ...(canvases[substepId] || []),
                              ...(videos[substepId] || []),
                            ];
                            const globalSubstepLabel = `Substep ${globalStepNumber}${substepLetter}`;

                            const globalRichTextNumber = richTextCounter; // ✅ use then increment
                            const globalAttachmentNumber = attachmentCounter;
                            const globalVideoNumber = videoCounter;
                            const globalCanvasNumber = canvasCounter;
                            const globalFormNumber = formCounter;

                            return (
                              <div
                                key={substepId}
                                style={{ marginTop: "20px", clear: "both" }}
                              >
                                <div>
                                  <HeadingWithTreePath
                                    title={globalSubstepLabel}
                                    treePathParams={{
                                      sectionIndex: index,
                                      stepIndex: globalStepNumber - 1,
                                      substepIndex: substepIndex,
                                      nodeType: undefined,
                                      nodeIndex: undefined,
                                    }}
                                  />
                                  <div style={{ whiteSpace: 'pre-wrap' }}>{substep.short_description}</div>
                                </div>

                                {/* Substep Rich Texts */}
                                {filteredItems.map((item, itemIndex) => {
                                  switch (item.type) {
                                    case "richText": {
                                      const globalRichTextNumber =
                                        richTextCounter++; // ✅ use then increment
                                      // render richText block here
                                      const label = (
                                        <h2
                                          style={{
                                            fontSize: "20px",
                                            margin: 0,
                                            clear: "both",
                                          }}
                                        >
                                          Rich Text {globalRichTextNumber}
                                        </h2>
                                      );

                                      return (
                                        <div
                                          key={item.rich_text_tree_node_id}
                                          style={{
                                            marginTop: "20px",
                                            clear: "both",
                                          }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              clear: "both",
                                            }}
                                          >
                                            <label
                                              style={{
                                                display: "flex",
                                                gap: "6px",
                                                cursor: "pointer",
                                                clear: "both",
                                              }}
                                            >
                                              {label}
                                            </label>

                                            <div
                                              style={{
                                                color: "#888",
                                                fontSize: "14px",
                                                fontWeight: "normal",
                                                clear: "both",
                                              }}
                                            >
                                              Section {currentSectionIndex + 1}{" "}
                                              &gt; Step {globalStepNumber} &gt;
                                              Substep {globalStepNumber}
                                              {String.fromCharCode(
                                                65 + substepIndex
                                              )}
                                            </div>
                                          </div>

                                          <div
                                            style={{
                                              marginLeft: "5px",
                                              marginTop: "-10px",
                                              clear: "both",
                                            }}
                                          >
                                            {item.short_description}
                                          </div>
                                          <div
                                            style={{
                                              marginLeft: "4px",
                                              marginTop: "10px",
                                              clear: "both",
                                            }}
                                          >
                                            {item.category_data?.category_name}
                                          </div>
                                          <div
                                            style={{
                                              fontSize: "14px",
                                              marginLeft: "4px",
                                              marginTop: "5px",
                                              clear: "both",
                                            }}
                                          >
                                            <div
                                              style={{
                                                marginTop: "-6px",
                                                clear: "both",
                                              }}
                                              dangerouslySetInnerHTML={{
                                                __html: item.rich_text_content,
                                              }}
                                            />
                                          </div>
                                        </div>
                                      );
                                    }
                                    case "video": {
                                      const globalVideoNumber = videoCounter++; // ✅ use then increment
                                      const label = (
                                        <h2
                                          style={{
                                            fontSize: "20px",
                                            margin: 0,
                                          }}
                                        >
                                          Video {globalVideoNumber}
                                        </h2>
                                      );

                                      return (
                                        <div
                                          key={label}
                                          style={{
                                            marginTop: "20px",
                                            clear: "both",
                                          }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              clear: "both",
                                            }}
                                          >
                                            <label
                                              style={{
                                                display: "flex",
                                                gap: "6px",
                                                cursor: "pointer",
                                                clear: "both",
                                              }}
                                            >
                                              {label}
                                            </label>

                                            <div
                                              style={{
                                                color: "#888",
                                                fontSize: "14px",
                                                fontWeight: "normal",
                                                clear: "both",
                                              }}
                                            >
                                              Section {currentSectionIndex + 1}{" "}
                                              &gt; Step {globalStepNumber} &gt;
                                              Substep {globalStepNumber}
                                              {String.fromCharCode(
                                                65 + substepIndex
                                              )}
                                            </div>
                                          </div>

                                          {renderVideo(item)}

                                          <div>{item.video_url}</div>

                                          <div>{item.short_description}</div>
                                        </div>
                                      );
                                    }

                                    case "form": {
                                      const globalFormNumber = formCounter++; // ✅ use then increment
                                      const label = (
                                        <h2
                                          style={{
                                            fontSize: "20px",
                                            margin: 0,
                                          }}
                                        >
                                          Form {globalFormNumber}
                                        </h2>
                                      );
                                      // render form block here
                                      return (
                                        <div
                                          key={label}
                                          style={{ clear: "both" }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              marginTop: "20px",
                                              clear: "both",
                                            }}
                                          >
                                            <label
                                              style={{
                                                display: "flex",
                                                gap: "6px",
                                                cursor: "pointer",
                                              }}
                                            >
                                              {label}
                                            </label>

                                            <div
                                              style={{
                                                color: "#888",
                                                fontSize: "14px",
                                                fontWeight: "normal",
                                              }}
                                            >
                                              Section {currentSectionIndex + 1}{" "}
                                              &gt; Step {globalStepNumber} &gt;
                                              Substep {globalStepNumber}
                                              {String.fromCharCode(
                                                65 + substepIndex
                                              )}
                                            </div>
                                          </div>
                                          <div>{item.short_description}</div>
                                        </div>
                                      );
                                    }
                                    case "canvas": {
                                      const pages = getPages(item);

                                      const globalCanvasNumber =
                                        canvasCounter++; // ✅ use then increment
                                      const label = (
                                        <h2
                                          style={{
                                            fontSize: "20px",
                                            margin: 0,
                                          }}
                                        >
                                          Canvas {globalCanvasNumber}
                                        </h2>
                                      );
                                      const shapes = item.shapes || [];

                                      return (
                                        <div
                                          key={label}
                                          style={{
                                            marginTop: "40px",
                                            clear: "both",
                                          }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              clear: "both",
                                            }}
                                          >
                                            <label
                                              style={{
                                                display: "flex",
                                                gap: "6px",
                                                cursor: "pointer",
                                                clear: "both",
                                              }}
                                            >
                                              <h2>{label}</h2>
                                            </label>

                                            <div
                                              style={{
                                                color: "#888",
                                                fontSize: "14px",
                                                fontWeight: "normal",
                                              }}
                                            >
                                              Section {currentSectionIndex + 1}{" "}
                                              &gt; Step {globalStepNumber} &gt;
                                              Substep {globalStepNumber}
                                              {String.fromCharCode(
                                                65 + substepIndex
                                              )}
                                            </div>
                                          </div>

                                          <div>{item.short_description}</div>

                                          {/* Display all pages vertically */}
                                          <CanvasDisplay pages={pages} />
                                        </div>
                                      );
                                    }
                                    case "attachment": {
                                      const attachmentList =
                                        item.attachments || [];
                                      if (attachmentList.length === 0)
                                        return null;

                                      //  const globalAttachmentNumber =
                                      //           attachmentCounter++; // ✅ use then increment
                                      const globalAttachmentNumber =
                                        attachmentCounter++; // ✅ Increment here per attachment
                                      const label = (
                                        <h2
                                          style={{
                                            fontSize: "20px",
                                            margin: 0,
                                          }}
                                        >
                                          Attachment {globalAttachmentNumber}
                                        </h2>
                                      );

                                      return (
                                        <div key={item}>
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                              marginTop: "20px",
                                              clear: "both",
                                            }}
                                          >
                                            <label
                                              style={{
                                                display: "flex",
                                                gap: "6px",
                                                cursor: "pointer",
                                                clear: "both",
                                              }}
                                            >
                                              {label}
                                            </label>

                                            <div
                                              style={{
                                                color: "#888",
                                                fontSize: "14px",
                                                fontWeight: "normal",
                                                clear: "both",
                                              }}
                                            >
                                              Section {currentSectionIndex + 1}{" "}
                                              &gt; Step {globalStepNumber} &gt;
                                              Substep {globalStepNumber}
                                              {String.fromCharCode(
                                                65 + substepIndex
                                              )}
                                            </div>
                                          </div>
                                          <div>{item.short_description}</div>
                                          {attachmentList.map(
                                            (attachment, i) => (
                                              <div
                                                key={i}
                                                style={{
                                                  marginLeft: "20px",
                                                  clear: "both",
                                                }}
                                              >
                                                {renderPreview(attachment)}
                                              </div>
                                            )
                                          )}
                                        </div>
                                      );
                                    }
                                    default:
                                      return null;
                                  }
                                })}
                              </div>
                            );
                          }
                        )}
                      </div>
                    );
                  }
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* Snackbar */}
      {snackbar.open && (
        <Snackbar
          message={snackbar.message}
          type={snackbar.type}
          onClose={handleCloseSnackbar}
        />
      )}

      {/* Modal */}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content_addsection">
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              <h4
                style={{
                  marginLeft: "23px",
                  fontSize: "18px",
                  color: "#333333",
                }}
              >
                Confirm {createCopy ? "Copy" : "Move"} of Section{" "}
                {sourceSectionIndex + 1}{" "}
                {moveType === "up"
                  ? "Above"
                  : moveType === "below"
                  ? "Below"
                  : "Into"}{" "}
                {moveType === "into"
                  ? `${type} ${partNumber}`
                  : `Section ${targetSectionIndex + 1}`}
              </h4>
              <button
                onClick={() => setModalOpen(false)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "10px",
                  background: "none",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                  color: "#666",
                }}
                disabled={isModalLoading}
              >
                ✕
              </button>
            </div>

            {/* Modal Body */}
            <div
              style={{ padding: "24px", marginTop: "-28px", color: "#333333" }}
            >
              <h4 style={{ fontSize: "14px" }}>
                For {type} {partNumber} - Rev {revision}
              </h4>

              <p style={{ fontSize: "14px", color: "#333333" }}>
                <strong>Editor:</strong>{" "}
                <span style={{ marginLeft: "10px" }}>
                  {localStorage.getItem("user_name")}
                </span>
              </p>

              <label
                className="modal-label"
                style={{ fontSize: "14px", color: "#333333" }}
              >
                Comment<span className="required">*</span>
              </label>
              <textarea
                className="modal-textarea"
                placeholder="Enter your comments here..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                style={{
                  width: "100%",
                  minHeight: "100px",
                  padding: "8px",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                }}
                disabled={isModalLoading}
              ></textarea>
            </div>

            {/* Footer */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                padding: "16px 24px",
                borderTop: "1px solid #e0e0e0",
                marginTop: "-10px",
                position: "relative",
              }}
            >
              {isModalLoading && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                    zIndex: 10,
                  }}
                >
                  <div
                    className="loader-spinner"
                    style={{
                      border: "4px solid #f3f3f3",
                      borderRadius: "50%",
                      width: "20px",
                      height: "20px",
                      animation: "spin 1s linear infinite",
                      marginRight: "10px",
                    }}
                  ></div>
                  <span>{createCopy ? "Copying..." : "Moving..."}</span>
                </div>
              )}
              <button
                onClick={() => setModalOpen(false)}
                style={{
                  padding: "8px 16px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  background: "#6c757d",
                  color: "#e9ecef",
                  cursor: isModalLoading ? "not-allowed" : "pointer",
                }}
                disabled={isModalLoading}
              >
                Close
              </button>
              <button
                onClick={handleConfirmSave}
                style={{
                  padding: "8px 16px",
                  border: "1px solid #007bff",
                  borderRadius: "4px",
                  background: "#007bff",
                  color: "white",
                  cursor: isModalLoading ? "not-allowed" : "pointer",
                  opacity: isModalLoading ? 0.7 : 1,
                }}
                disabled={isModalLoading}
              >
                {isModalLoading
                  ? createCopy
                    ? "Copying..."
                    : "Moving..."
                  : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProcedureSectionMovePreview;
